import Typography, { TypographyProps } from '@mui/material/Typography';

import useSiteDateFormat from 'hooks/useSiteDateFormat';
import { DATE_PLACEHOLDER, formatDateWithPattern } from 'utils/dateFormatter';

interface DateLabelProps extends Omit<TypographyProps, 'children'> {
  /** ISO string from the API, a Date, or null when not set. */
  value: string | Date | null | undefined;
}

/**
 * Displays a date using the selected site's configured date format.
 *
 * Use this anywhere a date is shown, rather than formatting inline — the format is a per-site
 * setting, so a hard-coded pattern (or a raw ISO substring) is wrong for any site configured
 * differently, and it's how one screen ends up showing 2026-03-28 next to another showing 28/03/2026.
 */
export default function DateLabel({ value, variant = 'body2', color, ...typographyProps }: DateLabelProps) {
  const dateFormat = useSiteDateFormat();
  const formatted = formatDateWithPattern(value, dateFormat);
  const isPlaceholder = formatted === DATE_PLACEHOLDER;

  return (
    <Typography variant={variant} color={color ?? (isPlaceholder ? 'text.secondary' : undefined)} {...typographyProps}>
      {formatted}
    </Typography>
  );
}
